import React from 'react';

export default function Resume() {
  return (
    <div>
      <h1>Resume</h1>
          <a class="nav-item nav-link" href="./Chris Duhaime Resume.odt">Download Resume</a>
      <img className="mx-auto d-block border"  src="images/Screenshot 2022-07-12 111256.png" alt="resume"></img>
    </div>
  );
}
